import { render, staticRenderFns } from "./ColorCategoryForm.vue?vue&type=template&id=21134d37&"
import script from "./ColorCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ColorCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./ColorCategoryForm.vue?vue&type=style&index=0&id=21134d37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports